import React from "react";
import Terminal from "./components/Terminal";

function App() {
  return (
    <div style={{ background: "#121212", height: "100vh", margin: 0 }}>
      <Terminal />
    </div>
  );
}

export default App;
